<div class="facet-values-list" *ngIf="facets$ | async as valueList">
  <vdr-facet-value-chip
    *ngFor="let value of valueList | slice : 0 : displayLimit || 3"
    [facetValue]="value"
    [removable]="false"
    [displayFacetName]="false"
  ></vdr-facet-value-chip>

  <!-- <vdr-chip
    [icon]="removable ? 'times' : undefined"
    [colorFrom]="facetValue.facet.name"
    (iconClick)="remove.emit()"
    [title]="facetValue.facet.name + ' - ' + facetValue.name"
  >
    <span *ngIf="displayFacetName" class="facet-name">{{
      facetValue.facet.name
    }}</span>
    <span>{{ facetValue.name }}</span>
  </vdr-chip> -->
  <!-- <vdr-chip *ngIf="displayLimit[facet.id] < valueList.length && (displayLimit[facet.id] || 0) === valueList.length">
        ... + {{ facet.valueList.totalItems - facet.valueList.items.length }}
    </vdr-chip> -->
  <button
    class="button-small"
    *ngIf="valueList.length > initialLimit"
    (click)="toggleDisplayLimit()"
  >
    <ng-container *ngIf="(displayLimit || 0) < valueList.length; else collapse">
      <clr-icon shape="plus"></clr-icon>
      {{ valueList.length - initialLimit }}
    </ng-container>
    <ng-template #collapse>
      <clr-icon shape="minus"></clr-icon>
    </ng-template>
  </button>
</div>
